import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { SelectFieldOption } from '@sdbn/common';
import { ConditionEditorContext, ConditionEditorContextConsumer, ConditionEntry } from '@sdbn/common-extended';
import { Subject, Subscription } from 'rxjs';
import { ProcessingStatusModel } from '../../../client/model/processing-status-model';
import { TmcContextService } from '../../../common/tmc-context.service';

@Component({
  selector: 'yard-processing-status-condition-editor',
  standalone: false,
  templateUrl: './processing-status-condition-editor.component.html',
  styleUrl: './processing-status-condition-editor.component.scss',
})
export class ProcessingModuleConditionEditorComponent implements OnInit, ConditionEditorContextConsumer {

  condition: ConditionEntry;

  formGroup = new FormGroup({
    process: new FormControl(null, []),
    processStep: new FormControl(null, [])
  });

  processSelectOptions = new Array<SelectFieldOption>();
  processStepSelectOptions = new Array<SelectFieldOption>();

  tmcContextSubscription: Subscription;

  currenProcess: ProcessingStatusModel | null = null;

  changing: boolean = false;

  constructor(
    private tmcContextService: TmcContextService
  ) {

  }

  setConditionEditorContext(context: ConditionEditorContext): void {
    context.selectedCondition.subscribe(
      condition => {
        this.condition = condition;
        let dataObject = condition.data ? JSON.parse(condition.data) : null;
        if (dataObject) {
          this.formGroup.patchValue({
            process: dataObject.process,
            processStep: dataObject.processStep
          });
        }
      }
    );
  }

  setChangedSubject(changed: Subject<void>): void {
  }

  ngOnInit(): void {

    this.tmcContextSubscription = this.tmcContextService.updated.subscribe(next => {
      if (next != null) {
        let processSelectOptions = new Array<SelectFieldOption>();
        for (const model of this.tmcContextService.getYardConfiguration().processingStatusModels) {
          processSelectOptions.push(new SelectFieldOption({ labelDictionaryKey: model.nameDictionaryKey, value: model.key }));
        }
        this.processSelectOptions = processSelectOptions;
      }
    });

    this.formGroup.valueChanges.subscribe(value => {
      if (!this.changing) {
        this.changing = true;
        let processChanged = value.process !== this.currenProcess?.key;
        console.log('processing chages', value, this.currenProcess, processChanged);
        if (processChanged) {
          this.currenProcess = this.tmcContextService.getYardConfiguration().processingStatusModels.find(p => p.key === value.process!) || null;
          this.updateProcessSteps(this.currenProcess);
        }
        this.condition.data = JSON.stringify(value);
        this.changing = false;
      }
    });

  }

  private updateProcessSteps(process: ProcessingStatusModel | null) {
    console.log('updating for process', process);
    if (process) {
      let processStepSelectOptions = new Array<SelectFieldOption>();
      for (const status of process.status) {
        processStepSelectOptions.push(new SelectFieldOption({ labelDictionaryKey: status.dictionaryKey, value: status.key }));
      }
      this.processStepSelectOptions = processStepSelectOptions;
    }
  }

}
